/**
 * wysiwyg-visual-tools/index.ts
 *
 * Ponto de entrada do sistema de plugins do Smart Visual Editor.
 * Para adicionar um novo plugin:
 *   1. Crie plugins/meu-plugin.ts implementando VtbPlugin
 *   2. Importe e registre aqui (ordem = prioridade de detecção)
 *   3. Adicione o painel Blade em ai-component-library-modal.blade.php
 *   → zero alterações em component-library-modal.ts
 */

import { VtbRegistry } from './registry';

import { ChecklistItemPlugin  } from './plugins/checklist-item';
import { BadgePlugin          } from './plugins/badge';
import { BadgesGroupPlugin    } from './plugins/badges-group';
import { MetaFieldPlugin      } from './plugins/meta-field';
import { AlertPlugin          } from './plugins/alert';
import { EndpointPlugin       } from './plugins/endpoint';
import { TableRowPlugin       } from './plugins/table-row';
import { DeployBoxPlugin      } from './plugins/deploy-box';
import { CodeExamplePlugin    } from './plugins/code-example';
import { ListItemPlugin       } from './plugins/list-item';
import { DocHeaderPlugin     } from './plugins/doc-header';
import { OrgChartPlugin      } from './plugins/orgchart';
import { FlowchartPlugin     } from './plugins/flowchart';
import { CoverPlugin        } from './plugins/cover';
import { DividerPlugin      } from './plugins/divider';
import { DetailsPlugin       } from './plugins/details';
import { QuotePlugin         } from './plugins/quote';
import { GridPlugin        } from './plugins/grid';
import { CardPlugin        } from './plugins/card';
import { LogosTargetPlugin   } from './plugins/logos-target';
import { TitlesPlugin      } from './plugins/titles';

/**
 * Cria e configura o registry com todos os plugins em ordem de prioridade.
 * Plugins mais específicos devem vir ANTES dos genéricos.
 */
export function createVtbRegistry(): VtbRegistry {
    const registry = new VtbRegistry();

    // ── Ordem de detecção (mais específico → mais genérico) ────────────────
    registry.register(new DocHeaderPlugin());      // div.page-header:has(.header-top)
    registry.register(new TitlesPlugin());         // h1-h6 (antes de genéricos)
    registry.register(new CoverPlugin());          // .cover
    registry.register(new GridPlugin());           // .tool-grid, .cards, .hierarchy
    registry.register(new CardPlugin());           // itens do grid
    registry.register(new QuotePlugin());          // .business-quote
    registry.register(new DetailsPlugin());        // details/summary
    registry.register(new DividerPlugin());        // .section-divider
    registry.register(new OrgChartPlugin());       // div.org-chart (antes de ListItem)
    registry.register(new FlowchartPlugin());      // div.flowchart  (antes de ListItem)
    registry.register(new ChecklistItemPlugin()); // li.checklist > li  (antes de ListItem)
    registry.register(new LogosTargetPlugin());    // img (logo target)
    registry.register(new BadgePlugin());          // span.badge
    registry.register(new BadgesGroupPlugin());    // div.badges         (depois de Badge)
    registry.register(new MetaFieldPlugin());      // span em .meta
    registry.register(new AlertPlugin());          // div.alert
    registry.register(new EndpointPlugin());       // div.endpoint
    registry.register(new TableRowPlugin());       // tr (fora de .endpoint)
    registry.register(new DeployBoxPlugin());      // div.deploy-box
    registry.register(new CodeExamplePlugin());    // pre.code-example
    registry.register(new ListItemPlugin());       // li genérico (última — mais amplo)

    return registry;
}

export { VtbRegistry };
export * from './types';
